export default "__VITE_ASSET__CDCqYJhP__"